import React from 'react';
import Spinner from 'pages/Dashboard/components/Spinner';
import {
  Button,
} from '@populateui/ui';

type Props = {
  continueLabel: string;
  onContinue: () => void;
  isSaving?: boolean;
};

export default function EmptyWorkflowStepBar({
  continueLabel,
  onContinue,
  isSaving = false,
}: Props) {
  return (
    <div className="flex flex-col gap-4 px-4 w-3/4 max-w-[870px]">
      <p className="text-sm text-gray-600">
        This form has no clinician fields to complete. Review the document below, then continue.
      </p>
      <div className="flex gap-4 flex-1 items-center">
        <Button
          variant="contained"
          color="primary"
          disabled={isSaving}
          className="min-w-32 w-auto h-8 !py-0 !capitalize flex gap-2 items-center"
          onClick={onContinue}
          type="button"
        >
          {isSaving && <Spinner />}
          {isSaving ? 'Saving...' : continueLabel}
        </Button>
      </div>
    </div>
  );
}
